import React from 'react';

const Footer = () => {
	return(
		<div className='footerContainer' style={{background:'black'}}>
		</div>
	)
}

export default Footer;